import { render } from "./StageCode.vue?vue&type=template&id=37cc3bcc&scoped=true"
import script from "./StageCode.vue?vue&type=script&lang=js"
export * from "./StageCode.vue?vue&type=script&lang=js"

import "./StageCode.vue?vue&type=style&index=0&id=37cc3bcc&lang=css"
import "./StageCode.vue?vue&type=style&index=1&id=37cc3bcc&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37cc3bcc"]])

export default __exports__